<template>
  <div
    v-if="visible"
    class="section-intro d-flex align-items-start gap-2 mb-3"
    role="note"
  >
    <i class="fas fa-lightbulb mt-1 flex-shrink-0"></i>
    <div class="flex-grow-1"><slot>{{ text }}</slot></div>
    <button
      v-if="dismissible"
      type="button"
      class="btn-close flex-shrink-0"
      aria-label="بستن راهنما"
      @click="dismiss"
    ></button>
  </div>
</template>

<script>
import { hasSeenGuide, markGuideSeen } from "@/utils/guide";

export default {
  name: "SectionIntro",
  props: {
    // شناسه‌ی یکتا برای این توضیح (مثل "tickets")
    introId: { type: String, required: true },
    text: { type: String, default: "" },
    // اگر true باشد، پس از بستن دیگر نمایش داده نمی‌شود (اولین‌مراجعه)
    dismissible: { type: Boolean, default: true },
  },
  data() {
    return {
      visible: !this.dismissible || !hasSeenGuide("intro:" + this.introId),
    };
  },
  methods: {
    dismiss() {
      this.visible = false;
      markGuideSeen("intro:" + this.introId);
    },
  },
};
</script>

<style scoped>
.section-intro {
  background: rgba(243, 91, 33, 0.07);
  border: 1px solid rgba(243, 91, 33, 0.22);
  color: var(--bndbs-text, #2b2f38);
  border-radius: 0.6rem;
  padding: 0.7rem 0.9rem;
  font-size: 0.9rem;
  line-height: 1.9;
}
.section-intro .fa-lightbulb {
  color: var(--bndbs-primary, #f35b21);
}
</style>
